import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { useAuthContext } from '../../../hooks/useAuthContext';


const CreateRequestForm = () => {
    const [reqDate, setReqDate] = useState(new Date());
    const [customer, setCustomer] = useState('');
    const [brand, setBrand] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState(new Date().getFullYear());
    const [size, setSize] = useState('');
    const [refNum, setRefNum] = useState('');
    const [condition, setCondition] = useState('New');
    const [box, setBox] = useState(true);
    const [papers, setPapers] = useState(true);
    const [reqQuote, setReqQuote] = useState(0);
    const [notes, setNotes] = useState('');
    const [error, setError] = useState(null);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    const navigate = useNavigate();

    //function to handle when form is submitted. Will POST a new request to the DB
    const handleSubmit = async (event) => {
        event.preventDefault();

        const watchRequest = {
            reqDate, customer, brand, model, year, size,
            refNum, condition, box, papers, 
            reqQuote, notes
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_SERVER_URL + '/api/watchRequests', 
                watchRequest, 
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            console.log('Watch Request Added: ' + response.data);
            //reset form values
        } catch (e) {
            console.log(e.response.data.error);
            setError(e.response.data.error);
        }
        
        navigate('/main/home');
    }

    return (
        <form className="modal-form" onSubmit={user ? handleSubmit : null}>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Date Of Request</label>
                    <input 
                        className="form-control"
                        type="date"
                        onChange={(event) => setReqDate(event.target.value)}
                        value={reqDate} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Customer Name</label>
                    <input
                        className="form-control"
                        type="text"
                        onChange={(event) => setCustomer(event.target.value)}
                        value={customer} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Brand</label>
                    <input
                        className="form-control" 
                        type="text"
                        onChange={(event) => setBrand(event.target.value)}
                        value={brand} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Model</label>
                    <input
                        className="form-control" 
                        type="text"
                        onChange={(event) => setModel(event.target.value)}
                        value={model} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Year</label>
                    <input
                        className="form-control" 
                        type="number"
                        onChange={(event) => setYear(event.target.value)}
                        value={year} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Size</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setSize(event.target.value)}
                        value={size} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Reference Number</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setRefNum(event.target.value)}
                        value={refNum} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Condition</label>
                    <select
                        className="form-select"
                        onChange={(event) => setCondition(event.target.value)}
                        value={condition} 
                    > 
                        <option value="New">New</option>
                        <option value="Preowned">Preowned</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Box</label>
                    <select
                        className="form-select"
                        onChange={(event) => setBox(event.target.value)}
                        value={box} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Papers</label>
                    <select
                        className="form-select"
                        onChange={(event) => setPapers(event.target.value)}
                        value={papers} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Customer Quote</label>
                    <input
                        className="form-control" 
                        type="number"
                        onChange={(event) => setReqQuote(event.target.value)}
                        value={reqQuote} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Additional Notes</label>
                    <textarea
                        className="form-control"
                        onChange={(event) => setNotes(event.target.value)}
                        value={notes}
                        rows={4}
                        cols={40}
                    />
                </div>
            </div>

            <button type="submit" className="btn btn-light">Create Request</button>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default CreateRequestForm;